




















import {Component, Prop, Vue} from "vue-property-decorator";
import {bus} from "@/plugins/bus";

@Component
export default class SearchInput extends Vue {
  inputField: string = '';

  mounted() {
    (this.$refs.searchInput as any).focus();
  }

  searchText() {
    bus.$emit('filterList', this.inputField);
  }

  closeSearch() {
    bus.$emit('searchToggle', false);
  }

  clearSearch() {
    this.inputField = '';
    bus.$emit('filterList', this.inputField);
  }
}
